import i18n from '@/utils/i18n';
import React from 'react';
import {
  Separator,
  Skeleton,
  View,
  XStack,
  YStack,
} from '@usepepper/sprout-kit-ui';
import {
  UNPAID_INVOICES_TABLE_COLUMNS,
  UNPAID_INVOICES_TABLE_ROW_HEIGHT,
} from '@finance-hub/domain/invoicing/components/unpaid-invoices-table-columns';
import { useTheme } from '@/contexts/theme-context';

const SKELETON_BAR_HEIGHT = 14;
const SKELETON_BAR_WIDTH = 88;

interface Props {
  count: number;
}

export const UnpaidInvoicesTableSkeletonRows: React.FC<Props> = ({ count }) => {
  const theme = useTheme();

  return (
    <YStack accessibilityLabel={i18n.t('loading')} width="100%">
      {Array.from({ length: count }, (_, index) => (
        <React.Fragment key={`skeleton-row-${index}`}>
          <XStack
            alignItems="center"
            minHeight={UNPAID_INVOICES_TABLE_ROW_HEIGHT}
            paddingVertical="$16"
          >
            {UNPAID_INVOICES_TABLE_COLUMNS.map((column) => (
              <View
                key={column.sortField}
                paddingHorizontal="$8"
                width={`${column.initialPercentWidth}%`}
              >
                <Skeleton
                  borderRadius={theme.sk.radii.radiusRound}
                  height={SKELETON_BAR_HEIGHT}
                  maxWidth="100%"
                  variant="rect"
                  width={SKELETON_BAR_WIDTH}
                />
              </View>
            ))}
          </XStack>
          <Separator />
        </React.Fragment>
      ))}
    </YStack>
  );
};
